export { JobDescriptionCalloutDetails } from './JobDescriptionCalloutDetails';
